import styled from 'styled-components';

export const StyledStarTitle = styled.span`
    color: white;
    font-size: 85px;
    font-weight: bold;
    font-family: sans-serif;
    text-transform: uppercase;
    position: relative;
    user-select: none;
    filter: brightness(200%);
    text-align: center;
    letter-spacing: 3px;

@media only screen and (max-width: 850px) {
font-size: 8.5vw;
}

&::before {
    content: '${(props) => props.text}';
    position: absolute;
    //color: white;
    color: #a8cbff;
    filter: blur(0.02em);
    mix-blend-mode: difference;
}
`;

export const StyledStarTitleWrapper = styled.div`
display: flex;
align-items: center;
justify-content: center;
box-sizing: content-box;
line-height: 1;
`;
